// HookRelay is a hook mounted in the layout existing solely to expose the
// LiveView hook API to other JavaScript, such as in Stimulus controllers,
// globally via custom events on `window`. As such, it adheres closely in
// naming to that API, including event names and argument names. See the
// documentation for these hook methods here:
// https://hexdocs.pm/phoenix_live_view/js-interop.html#client-hooks-via-phx-hook
//
// For example, to call `pushEvent` from a Stimulus controller, dispatch a
// CustomEvent like so:
//
// window.dispatchEvent(new CustomEvent("vulcan:hook-relay:push-event", {
//  detail: {
//    event: "name-of-event-to-push",
//    payload: { "any-event-attrs": "here" }
//  }
// }))

export const HookRelay = {
  mounted() {
    window.addEventListener('vulcan:hook-relay:push-event', (e) => {
      this.pushEvent(e.detail.event, e.detail.payload);
    });

    window.addEventListener('vulcan:hook-relay:push-event-to', (e) => {
      this.pushEventTo(e.detail.selectorOrTarget, e.detail.event, e.detail.payload);
    });

    window.addEventListener('vulcan:hook-relay:handle-event', (e) => {
      this.handleEvent(e.detail.event, e.detail.callback);
    });

    window.addEventListener('vulcan:hook-relay:upload', (e) => {
      this.upload(e.detail.name, e.detail.files);
    });

    window.addEventListener('vulcan:hook-relay:upload-to', (e) => {
      this.uploadTo(e.detail.selectorOrTarget, e.detail.name, e.detail.files);
    });
  }
};
